$(function () {
    /*
     Decorate event function on debounce classes
     It basically wraps the click function to give it a delay before
     firing the click event.

     example : adding 'debounce-300' has a class on a button reports
     the click event by 300 ms
     */
    $("[class*=debounce-]").each(function (event) {

        var originalFunction = $(this).attr('onclick');
        var classes = $(this).attr('class');
        var pattern = /debounce-([0-9]+)/;
        var matchers = pattern.exec(classes);

        if (!!matchers && !!matchers[1]) {
            $(this).attr("onclick", "").unbind("click");
            $(this).on('click', $.debounce((function (e) {
                return function (e) {
                    eval(originalFunction);
                }
            }(originalFunction)), matchers[1]));
        }
    });
});